import {TCString} from "../../tcstring/t-c-string";
import {ECMPWindow} from "../../ui/window/interface";
import {UIManager} from "../../ui/u-i-manager";

interface ICMPInfo {
    cmp_version: number;
    cmp_window?: ECMPWindow;
}

export class CMPInfo implements ICMPInfo {
    /* STATIC */
    public static build(tcString: TCString): CMPInfo {
        return new CMPInfo({
            cmp_version: tcString.cmpVersion(),
            cmp_window: UIManager.cmpWindowDisplayed()?.id
        });
    }

    /* INSTANCE */
    private constructor(private readonly _data: ICMPInfo) {
    }

    public get data(): ICMPInfo {
        return this._data;
    }

    public get cmp_version(): number {
        return this.data.cmp_version;
    }

    public get cmp_window(): ECMPWindow|undefined {
        return this.data.cmp_window;
    }

}
